const STORAGE_LOCATION_COL_ID_PREFIX = "storageLocation"

/** Column id of a warehouse's stock-level column ("storageLocation" + the location id, no spaces). */
export const storageLocationColId = (locationId: string) =>
  `${STORAGE_LOCATION_COL_ID_PREFIX}${locationId.replace(" ", "")}`

/** Is this one of the per-warehouse stock-level columns? */
export const isStorageLocationColId = (colId: string) =>
  colId.startsWith(STORAGE_LOCATION_COL_ID_PREFIX)
